export const state = {
  addAdminAccount: {},
  updateAdminAccount: {},
  adminAccount: {
    adminUserName: '',
    authority: '',
    mailAddress: '',
    password: ''
  },
  adminAccounts: [],
  adminAccountMasterAuthorityFlg: false,
  exportData: [],
  total: 0,
  selectedAccountList: []
}
export const mutations = {
  setAdminAccounts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedAccountList.some(
          selectedAccount =>
            selectedAccount.adminUserId ===
            response.data['data'][i]['adminUserId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.adminAccounts = response.data['data']
    state.total = response.data['header']['total']
  },
  setExportData(state, response) {
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    state.adminAccount = response.data['data'][0]
    state.updateAdminAccount = {}
    state.updateAdminAccount.adminUserId = state.adminAccount.adminUserId
    if (state.adminAccount.authority === 'マスター管理者') {
      state.adminAccountMasterAuthorityFlg = true
    } else {
      state.adminAccountMasterAuthorityFlg = false
    }
  },
  inputUpdate(state, payload) {
    state.updateAdminAccount[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addAdminAccount[payload.name] = payload.value
  },
  clearAddUpdate(state) {
    state.addAdminAccount = {}
  },
  updateSelectedAccountList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedAccountList.some(
          account => account.adminUserId === payload[i].adminUserId
        )
      ) {
        state.selectedAccountList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedAccountList.some(
          account => account.adminUserId === payload[i].adminUserId
        )
      ) {
        const deleteIndex = state.selectedAccountList.findIndex(
          account => account.adminUserId === payload[i].adminUserId
        )
        state.selectedAccountList = state.selectedAccountList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedAccountList(state) {
    state.selectedAccountList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/adminAccountModules/adminAccountMutation.js